import { StepType } from '@ibe/services';
import { CheckoutStep } from './Models/CheckoutStep';

export const productIBEWorkflowCheckoutBase: CheckoutStep[] = [
  {
    type: StepType.OAG_PACKAGE_HOTEL,
    slug: 'packages',
    title: '',
    label: 'Packages',
    steps: null
  },
  {
    type: StepType.OAG_CHECKOUT_SUMMARY,
    slug: 'summary',
    title: '',
    label: 'Summary',
    steps: null
  },
  {
    type: StepType.OAG_CHECKOUT_EXTRAS,
    slug: 'extras',
    title: '',
    label: 'Extras',
    steps: null
  },
  {
    type: StepType.OAG_CHECKOUT_TRAVELERS,
    slug: 'traveler',
    title: '',
    label: 'Traveler',
    steps: null
  },
  {
    type: StepType.OAG_CHECKOUT_CONFIRMATION,
    slug: 'confirmation',
    title: '',
    label: 'Confirmation',
    steps: null
  }
];

export const productIBEWhitelabelWorkflowCheckoutBase: CheckoutStep[] = [
  {
    type: StepType.OAG_PACKAGE_HOTEL,
    slug: 'packages',
    title: '',
    label: 'Packages',
    steps: null
  },
  {
    type: StepType.OAG_CHECKOUT_SUMMARY,
    slug: 'summary',
    title: '',
    label: 'Summary',
    steps: null
  },
  {
    type: StepType.OAG_CHECKOUT_EXTRAS,
    slug: 'extras',
    title: '',
    label: 'Extras',
    steps: null
  },
  {
    type: StepType.OAG_CHECKOUT_TRAVELERS,
    slug: 'traveler',
    title: '',
    label: 'Traveler',
    steps: null
  },
  {
    type: StepType.OAG_CHECKOUT_CONFIRMATION,
    slug: 'confirmation',
    title: '',
    label: 'Confirmation',
    steps: null
  }
];
